export const PROFILE_INFO_HEIGHT = "30vh"
export const PROFILE_INFO_WIDTH = 12 * 0.75
export const PROFILE_POSTS_WIDTH = 8
export const PROFILE_PAGE_WIDTH = "70%"